import BASE_URL_WITH_PROTOCOL from "../../utils/dynamicUrl"
import IP from "../../utils/variable"

export const get_experience = (experience) => {
    
    if (experience == 0){
        return "Less than 1 Year"
    }

    if (experience == 11){
        return "More than 10 Years"
      }
    
        
    if (experience == 1){
      return `${experience} Year`

    }
    else{
        return `${experience} Years`
      }
  }

export const get_last_used = (last_used)  => {

      if (last_used == 0){
          return "Currently Using"
        }
      if (last_used == 1){
        return "Used less than 1 Year ago"
      }
      else{
        return `Less than ${last_used} Years ago`
      }
  }


export const formatPrice = (price) => {
  return new Intl.NumberFormat().format(price);
};



export const createPaymentProofLink = (url) => {

  
  if (process.env.NODE_ENV == "production"){
    
    let parsedUrl = new URL(url);
    
    // Remove query parameters
    parsedUrl.search = "";
    
    // Get the updated URL without query parameters
    return  parsedUrl.toString();
    
  }
  else {
 
      let baseURL = `${BASE_URL_WITH_PROTOCOL}`;
      
      return `${baseURL}${url}`
    
    }
  
  }


  export const getTrainingTax = (num) => {
    const result = num * 1.16;
    return Math.round(result).toLocaleString();
  }

  export const formatCurrency = (value) => {  
    if (!value) return '';
    
    const stringValue = String(value).replace(/[^0-9.-]+/g, "");
    
    const numericValue = parseFloat(stringValue);
    if (isNaN(numericValue)) return '';
    
    return `PKR ${numericValue.toLocaleString('en-US')}`;
};


